import * as React from "react";

import Spinner from "@src/lib/ui/Spinner";
import { cn } from "@src/lib/utils/cn";

type EmptyStateProps = React.HTMLAttributes<HTMLDivElement> & {
  loading?: boolean;
};

const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ loading = false, className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex flex-1 flex-col items-center justify-center self-stretch px-6 py-20",
          className,
        )}
        {...props}
      >
        {loading ? <Spinner /> : children}
      </div>
    );
  },
);
EmptyState.displayName = "EmptyState";

const EmptyStateIcon = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      "flex size-16 items-center justify-center text-icon-tertiary",
      className,
    )}
    {...props}
  />
));
EmptyStateIcon.displayName = "EmptyStateIcon";

const EmptyStateTitle = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "mt-2 text-center text-s-v4 font-medium-v4 text-text-primary",
      className,
    )}
    {...props}
  />
));
EmptyStateTitle.displayName = "EmptyStateTitle";

const EmptyStateDescription = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "mt-1 max-w-prose text-balance text-center text-s-v4 font-normal-v4 text-text-tertiary",
      className,
    )}
    {...props}
  />
));
EmptyStateDescription.displayName = "EmptyStateDescription";

// Row of follow-up actions (usually one outline Button) under the copy.
const EmptyStateActions = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "mt-4 flex flex-wrap items-center justify-center gap-2",
      className,
    )}
    {...props}
  />
));
EmptyStateActions.displayName = "EmptyStateActions";

export {
  EmptyState,
  EmptyStateIcon,
  EmptyStateTitle,
  EmptyStateDescription,
  EmptyStateActions,
};
